const taxTableCapitalArray =[  {"salary": 0, "taxRate": 0},
                               {"salary": 47026, "taxRate": .015},
                               {"salary": 518901, "taxRate": .020}
]
export default taxTableCapitalArray;